export const SWITCHER_CHANGE = 'SWITCHER_CHANGE';

export function changeSwitcher(index) {
    return {
        type: SWITCHER_CHANGE,
        index,
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/relativesSwitcher.js